import { useAppointmentAdapter } from "adapters/appointment";
import { IFrame } from "components/atoms/IFrame";

const OneAppointmentIFrame = () => {
  const { basePath, ref, src, title } = useAppointmentAdapter();
  return (
    <IFrame basePath={basePath} ref={ref} title={title} src={src}></IFrame>
  );
};

export { OneAppointmentIFrame };
